import { render, staticRenderFns } from "./birthday-component.vue?vue&type=template&id=18334317&scoped=true&"
import script from "./birthday-component.vue?vue&type=script&lang=ts&"
export * from "./birthday-component.vue?vue&type=script&lang=ts&"
import style0 from "./birthday-component.vue?vue&type=style&index=0&id=18334317&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18334317",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VRow,VToolbar,VToolbarTitle})
